import { useStyletron } from "baseui";
import { useGetTenantsQuery } from "../../services/resourceGroups/tenantApi";
import { LoadingView } from "../../components/LoadingView";
import Tenant from "./Tenant";
import { ICompany } from "@oqdo/automationapps/Agents/Organizations/Company";

const TenantsView = (props: { subscriptionId: string }) => {
  const [css, theme] = useStyletron();
  const { subscriptionId } = props;

  const { data, isLoading, isSuccess, error } = useGetTenantsQuery(subscriptionId);

  const tenants = data?.data;
  return (
    <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
      {tenants?.map((item: ICompany, index) => <Tenant key={item.id} tenant={item} subscriptionId={subscriptionId} />)}
    </LoadingView>
  );
};

export default TenantsView;
